export const IconHelpKnowledgeQuestion: {
  name: 'icon_help_knowledge_question-9355056e1299'
} = {
  name: 'icon_help_knowledge_question-9355056e1299'
}
